import { storageService } from '@core/js/services/storage.service';

import { FAILED_LOGIN_ATTEMPTS } from '@interlayer/js/app/components/main/Login/constants';
import { getSha256 } from '@interlayer/js/app/utils/getSha256';

export const isProceedLoginInNative = () => {
    const url = new window.URL(window.location.href);

    return Boolean(url.searchParams.get('IsUsePortalLogin'));
};

export const clearFailedLoginAttempts = (userData = {}) => {
    const storageData = storageService.local.getItem(FAILED_LOGIN_ATTEMPTS);

    if (!storageData) {
        return;
    }

    const failedLoginAttempts = Object.entries(storageData).reduce(async (acc, [key, value]) => {
        const keyHash = await getSha256(key);
        if (await getSha256(userData.email) !== keyHash && await getSha256(userData.username) !== keyHash) {
            acc[keyHash] = value;
        }

        return acc;
    }, {});

    storageService.local.setItem(FAILED_LOGIN_ATTEMPTS, failedLoginAttempts);
};
